const server = process.env.REACT_APP_API_URL || "http://localhost:8080";
export default server;